module.exports = __webpack_public_path__ + "static/media/YF85_03.04c03705.jpg";